import { isString } from './dataType'

const DAY = 3600 * 1000 * 24 // milliseconds a day
const HOUR = 3600 * 1000
const MINUTE = 60 * 1000
const SECOND = 1000
const GBInBytes = 1024 * 1024 * 1024
const MBInBytes = 1024 * 1024

export const format_size = (size, leng = 1) => {
	if (isString(size)) {
		size = Number(size) || 0
	}
	let result = Number(size) || 0

	if (result < 1000) {
		return result + 'B'
	} else if (result / 1024 < 1000) {
		result = result / 1024
		return result.toFixed(leng) + 'KB'
	} else if (result / (1024 * 1024) < 1000) {
		result = result / (1024 * 1024)
		return result.toFixed(leng) + 'MB'
	} else {
		result = result / (1024 * 1024 * 1024)
		return result.toFixed(leng) + 'GB'
	}
}

export const stringOfSize = function(bytes) {
	if (typeof bytes !== 'number') {
		return bytes
	}

	var texts = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB']
	var i = 0
	var digitals = 0

	while (bytes >= 1024) {
		bytes = bytes / 1024
		i++
	}

	digitals = i > 0 && bytes < 10 ? 1 : 0
	return bytes.toFixed(digitals) + ' ' + texts[i]
}

export const formatDate = function(time, style = 'yyyy-MM-dd') {
	var d = new Date(Number(time))
	var o = {
		'M+': d.getMonth() + 1, // month
		'd+': d.getDate(), // day
		'h+': d.getHours(), // hour
		'm+': d.getMinutes(), // minute
		's+': d.getSeconds(), // second
		S: d.getMilliseconds(), // millisecond
	}

	if (/(y+)/.test(style)) {
		style = style.replace(
			RegExp.$1,
			(d.getFullYear() + '').substr(4 - RegExp.$1.length),
		)
	}

	for (var k in o) {
		if (new RegExp('(' + k + ')').test(style)) {
			style = style.replace(
				RegExp.$1,
				RegExp.$1.length === 1
					? o[k]
					: ('00' + o[k]).substr(('' + o[k]).length),
			)
		}
	}

	return style
}

export const percent = function(number) {
	return (number || 0) * 100 + '%'
}

export const trimNumberToString = function(number, threshold) {
	if (typeof number === 'number') {
		threshold = threshold || 99

		return number > threshold ? threshold + '+' : number + ''
	}

	return '' + number
}

export const formatGBToInteger = function(bytes) {
	var gbNumber = bytes / GBInBytes

	return gbNumber.toFixed(0)
}

export const formatBytesToGBFloat = function(bytes) {
	var gbNumber = bytes / GBInBytes

	return gbNumber.toFixed(2)
}

export const formatBytesToGB = function(bytes) {
	var gbNumber = bytes / GBInBytes
	var floorGB = Math.floor(gbNumber)
	var floorBytes = floorGB * GBInBytes
	var differBiggerThan1M = bytes - floorBytes > 1 * MBInBytes

	return gbNumber.toFixed(differBiggerThan1M ? 3 : 0)
}

export const formatDay = function(time) {
	return Math.ceil(time / DAY)
}

export const formatMicros = function(micros) {
	if (typeof micros !== 'number') {
		return micros
	}

	var texts = ['μs', 'ms', 's']
	var i = 0
	var digitals = 2

	while (micros >= 1000 && i < texts.length - 1) {
		micros = micros / 1000
		i++
	}

	digitals = i > 0 && micros < 10 ? 2 : 0
	return micros.toFixed(digitals) + ' ' + texts[i]
}

export const formateTimeAgo = function(time) {
	var now = new Date()
	var diff = now.getTime() - Number(time)
	if (diff < SECOND) {
		return {
			type: 0,
			number: diff,
		}
	} else if (diff < MINUTE) {
		return {
			type: 1,
			number: Math.floor(diff / SECOND),
		}
	} else if (diff < HOUR) {
		return {
			type: 2,
			number: Math.floor(diff / MINUTE),
		}
	} else if (diff < DAY) {
		return {
			type: 3,
			number: Math.floor(diff / HOUR),
		}
	} else {
		return {
			type: 4,
			number: this.formatDate(Number(time), 'yyyy/MM/dd'),
		}
	}
}
